// extracted by mini-css-extract-plugin
module.exports = {"coupon_card":"Coupon2_coupon_card__Qho00"};